export default {
  'zh-CN': {
    login: {
      title: '登录',
      remember: '自动登录',
      forgot: '忘记密码',
      accountLogin: '账号登录',
      mobileLogin: '手机登录',
      submit: '登录',
      loginLoading: '登录中......',
      loginSuccess: '登录成功，正在跳转......',
      other: '其它登录方式',
      signup: '注册账户'
    }
  },
  'en-US': {
    login: {
      title: 'Login',
      remember: 'Remember me',
      forgot: 'Forgot your password?',
      accountLogin: 'Account Login',
      mobileLogin: 'Mobile Login',
      submit: 'Login',
      loginLoading: 'Login......',
      loginSuccess: 'Login Success，Jumping......',
      other: 'Sign in with',
      signup: 'Sign up'
    }
  }
};